import { render, staticRenderFns } from "./TenantsContainer.vue?vue&type=template&id=2d4e9e51&"
import script from "./TenantsContainer.vue?vue&type=script&lang=js&"
export * from "./TenantsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports